import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DoctorService} from '../../services/doctor/doctor.service';
import {DoctorModel} from '../../models/doctor/doctor.model';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {iResponse} from '../../models/response/response.model';
import {MatInput} from '@angular/material/input';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';

@Component({
  selector: 'app-doctor-edit',
    imports: [
        ReactiveFormsModule,
        MatInput
    ],
  templateUrl: './doctor-edit.component.html',
  styleUrl: './doctor-edit.component.sass'
})
export class DoctorEditComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    @Input() doctor!: DoctorModel;
    @Output() updated: EventEmitter<DoctorModel> = new EventEmitter<DoctorModel>();
    @Output() triggerDoctorEdit: EventEmitter<string> = new EventEmitter<string>();

    doctorForm: FormGroup = new FormGroup({
        email: new FormControl('', Validators.required),
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        mobilePhone: new FormControl(''),
        telePhone: new FormControl(''),
        skype: new FormControl(''),
        title: new FormControl(''),
    })

    constructor(
        private doctorService: DoctorService,
        private infoMessageService: InfoMessageService
    ) {
    }

    ngOnInit(): void {
        if (this.doctor) {
            this.doctorForm.patchValue(this.doctor);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    submit(): void {
        if (this.doctorForm.invalid) {
            this.doctorForm.markAllAsTouched();
            return;
        }

        this.update();
    }

    cancel(): void {
        this.triggerDoctorEdit.emit();
    }

    private update(): void {
        this.doctorService.updateDoctor(this.doctorForm.value, this.doctor.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<DoctorModel>) => {
                    this.updated.emit(response.data);
                    this.infoMessageService.createMessage('Arzt erfolgreich geändert', 'success');
                },
                error: (error) => {
                    console.error(error);
                }
            })
    }

}
